export enum GanttViewsEnum {
  MONTH = 'MONTH',
  YEAR = 'YEAR',
  THREE_MONTHS = 'THREE_MONTHS',
}
